import { TLang, ReplaceText, getCookie, CheckCN } from '@/utils/lang';
import { Modal } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import { router, withRouter } from 'umi';
import { unionFlag, getSessonStorage, checkUnifyShop } from '@/utils';
import { connect } from 'dva';
import './index.less';


const PurchaseLimitModal = (props) => {
  const {purchaseLimitModal, setPurchaseLimitModal, purchaseLimitInfo, pageSource, union, companyOrderType, unionCode, aggOrderH5Url} = props;

  const onConfirm = (type) => {
    if (type === 'see') {
      if (!purchaseLimitInfo?.maxPurchaseNum) {
        router.go(-1);
      } else {
        if (union||checkUnifyShop()) {
          if (companyOrderType === 1) {
            router.push({
              pathname: '/orders'
            });
          } else {
            window.df_sdk_common.location.href = aggOrderH5Url;
          }
        } else {
          window.df_sdk_common.location.href = window.location.origin + '/extraorder/allOrder?status=0';
        }
      }
    }
    if(type === 'selectSeat') {
      if (!purchaseLimitInfo?.maxPurchaseNum) {
        if (union||checkUnifyShop()) {
          if (companyOrderType === 1) {
            router.push({
              pathname: '/orders'
            });
          } else {
            window.df_sdk_common.location.href = aggOrderH5Url;
          }
        } else {
          window.df_sdk_common.location.href = window.location.origin + '/extraorder/allOrder?status=0';
        }
      } else {
        if (pageSource === 'order') {
          router.push({
            pathname: '/movieSeat'
          });
        } else {
          window.location.reload();
        }
      }
    }
  };

  return (
    <Modal
      visible={purchaseLimitModal}
      transparent
      maskClosable={false}
      onClose={() => setPurchaseLimitModal(false)}
      // title={getCookie('df_lang') === 'en-US' ? purchaseLimitInfo.showMainTitleEn : purchaseLimitInfo.showMainTitle}
      title={purchaseLimitInfo?.showMainTitle}
      className="purchaseLimit"
      wrapClassName="purchaseLimitWrap"
      footer={[
        {
          text: !purchaseLimitInfo?.maxPurchaseNum ? TLang('返回', 'home', false, false, null) : TLang('查看订单', 'home', false, false, null),
          onPress: () => {
            onConfirm('see');
          }
        },
        {
          text: !purchaseLimitInfo?.maxPurchaseNum ? TLang('查看订单', 'home', false, false, null) :  TLang('重新选座', 'home', false, false, null),
          onPress: () => {
            onConfirm('selectSeat');
          }
        }
      ]}
    >
      <div className="purchaseLimit_content">
        {/* {getCookie('df_lang') === 'en-US' ? purchaseLimitInfo. showViceTitleEn : purchaseLimitInfo.showViceTitle} */}
        {purchaseLimitInfo?.showViceTitle}
      </div>
    </Modal>
  );
};


const mapStateToProps = ({ cinema, initData }) => ({ ...cinema, unionConfig: initData.unionConfig });

export default connect(mapStateToProps)(PurchaseLimitModal);
